import { TypedMap } from 'flow/types/TypedMap';
import { EmailRecipient } from 'flow/types/TicketEventData';

interface Props {
    identity: TypedMap<EmailRecipient>;
    highlightName?: boolean;
}

const EmailIdentity = ({ identity, highlightName }: Props) => {
    const name = identity.get('name');
    const address = identity.get('address');

    return (
        <>
            {name ? (
                <div className="flex gap-x-2 text-gray-500">
                    <span className={highlightName ? 'font-bold' : ''}>
                        {name}
                    </span>
                    <EmailAddress address={address} />
                </div>
            ) : (
                <EmailAddress address={address} />
            )}
        </>
    );
};

export default EmailIdentity;

interface PropsEmailAddress {
    address: string;
}

const EmailAddress = ({ address }: PropsEmailAddress) => (
    <span className="text-gray-500">
        {'<'}
        <span className="text-gray-800">{address}</span>
        {'>'}
    </span>
);

EmailAddress.displayName = 'EmailAddress';
